import { useContext, useEffect, useRef } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

// Pide confirmación antes de salir de la pantalla mientras `when` sea verdadero:
//  - cerrar o recargar la pestaña: aviso nativo del navegador (beforeunload; el texto lo pone el
//    navegador, no se puede personalizar);
//  - navegar dentro de la app (menú, links, navigate()): se envuelve el navigator del router,
//    porque con <BrowserRouter> no existe useBlocker (solo funciona con un data router).
// No cubre el botón "atrás" del navegador.
export const useLeaveGuard = (when, message) => {
  const navigator = useContext(UNSAFE_NavigationContext)?.navigator;
  const messageRef = useRef(message);
  messageRef.current = message;

  useEffect(() => {
    if (!when) return undefined;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    if (!navigator) return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    const { push, replace } = navigator;
    const guard = (go) => (...args) => {
      if (window.confirm(messageRef.current)) go(...args);
    };
    navigator.push = guard(push);
    navigator.replace = guard(replace);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [when, navigator]);
};
